import { css } from 'lit';

export const spinnerStyle = css`
    @keyframes rotate360 {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    :host .spinner {
        vertical-align: middle;
        animation: rotate360 1s linear infinite;
    }
`;
